import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import sphereAnimationWhiteJson from '@/data/lottie-animations/sphereAnimationWhite.json'

const schema: LandingScreenSchema = {
	order: [
		'LandingLanguageButton',
		'LandingHead',
		'LandingTitle',
		'LandingLottieAnimation',
		'LandingProgressLoader',
		'LandingFooter',
	],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('male_yoga.landing.title_age'),
			size: 'small',
			customStyles: {
				marginLeft: '2rem',
				marginRight: '2rem',
			},
		}),

		LandingLottieAnimation: (): LandingComponentsConfig['LandingLottieAnimation'] => ({
			animationData: sphereAnimationWhiteJson,
			loop: true,
			customStyles: {
				height: '50vh',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
